$(document).ready(function () {
    var arrLang = { // 語言數組
        'en': { // 英文
            'navbar-faster-payment-system': 'Faster Payment System',
            'navbar-receiving-money': 'Receiving Money',
            'navbar-sending-money': 'Sending Money',
            'navbar-transfer-now': 'Get Started Now',
            'faster-payment-system-title': 'Faster Payment System(FPS)',
            'faster-payment-system-p1': 'Learn how Faster Payment System works and how to get started at Business e-Banking.',
            'receiving-money-title': 'Receiving Money',
            'set-up-title': 'Set Up FPS Addressing and Assign Default Account',
            // 'set-up-p1': 'With just a few steps, you can receive money instantly.',
            'set-up-p1': '1. At Hang Seng Business e-Banking, enter your mobile number, email address or FPS ID as the Addressing Identifier.',
            'set-up-p2': '2. Set your Hang Seng Business Account as the default account. ',
            'set-up-p3': '3. Complete the verification with one-time password sent to your registered mobile number/ email.',
            'set-up-p4': 'Note: <br> No need to set default account and the one-time password will not be applicable if you choose FPS ID as the Addressing Identifier.',
            'identifier-title': 'Tell Payer Your Addressing Identifier',
            'identifier-p1': 'From now on, your payer can pay you via FPS with your Addressing Identifier.',
            'waiting-for-transfer-title': 'Money in Your Account Instantly',
            'waiting-for-transfer-p1': 'Once the payer make the payment, the money will hit your bank account on a real time basis.',
            'sending-money-title': 'Sending Money',
            'get-payee-identifier-title': 'Get Payee’s Addressing Identifier',
            'get-payee-identifier-p1': 'Greater privacy for your payee, as only the Addressing Identifier is needed instead of the bank account number.',
            'transfer-to-payee-title': 'Transfer Money to Payee',
            'transfer-to-payee-p1': 'Transfer funds sleekly via online or mobile banking.',
            'transfer-instantly-title': 'Money in Payee Account Instantly',
            'transfer-instantly-p1': 'The money can hit payee’s account almost instantly on a 7x24 basis.',
            'transfer-now-title': 'Get Started Now',
            'transfer-now-p1': 'Faster Payment System is now available at <br /> Hang Seng Business e-Banking.',
            'transfer-now-b1': 'Logon',
            'transfer-now-p2': 'Do not have a business account with us?',
            'transfer-now-a1': 'Open Now',
            'transfer-now-p3': 'Not yet registered for Business e-Banking?',
            'transfer-now-a2': 'Register Now',
            'footer-p1': 'Important Message to Readers and Internet Privacy Policy Statement',
            'footer-p2': '© Hang Seng Bank Limited',
        },
        'sc': { // 簡體
            'navbar-faster-payment-system': '快速支付系统',
            'navbar-receiving-money': '收款',
            'navbar-sending-money': '付款',
            'navbar-transfer-now': '立即行动',
            'faster-payment-system-title': '快速支付系统(FPS)',
            'faster-payment-system-p1': '了解快速支付系统怎样运作，以及如何透过商业e-Banking启动服务。',
            'receiving-money-title': '收&nbsp;款',
            'set-up-title': '设立FPS账户绑定 及 <br /> 设定预设户口',
            // 'set-up-p1': '完成几个简单步骤完成，收款便可即时到户。',
            'set-up-p1': '1. 于恒生商业e-Banking，请选择以你的流动电话号码，电邮地址或FPS ID，作为快速支付账号。',
            'set-up-p2': '2. 并以你的恒生商业户口作为预设户口。',
            'set-up-p3': '3. 我们会向你于本行登记的流动电话号码／电邮地址发出一次性密码，请于收到后输入该密码以核实身份。',
            'set-up-p4': '注 <br> 若以FPS ID作为你的「快速支付账号」，毋须设定「预设户口」及将不会收到一次性密码核实身份。',
            'identifier-title': '向付款人提供你的快速支付账号',
            'identifier-p1': '此后，付款人只需以你提供的快速支付账号，便可作出付款。',
            'waiting-for-transfer-title': '收款即时到户',
            'waiting-for-transfer-p1': '付款人付款后，款项会即时转账至你的 <br /> 银行户口。',
            'sending-money-title': '付&nbsp;款',
            'get-payee-identifier-title': '取得收款人的快速支付密码',
            'get-payee-identifier-p1': '毋须银行户口号码，只需以快速支付密码，便可办妥一切。如此，你的收款人便可享更大私隐保障！',
            'transfer-to-payee-title': '转账予收款人',
            'transfer-to-payee-p1': '透过网上或流动理财，即可轻松完成转账。',
            'transfer-instantly-title': '付款即时到户',
            'transfer-instantly-p1': '全天候7×24随时可进行付款，而且款项可近乎即时转至收款人户口。',
            'transfer-now-title': '立即行动',
            'transfer-now-p1': '快速支付系统现已登陆 <br /> 恒生商业e-Banking',
            'transfer-now-b1': '登入',
            'transfer-now-p2': '尚未持有恒生商业户口？',
            'transfer-now-a1': '立即开户',
            'transfer-now-p3': '未登记使用商业e-Banking？',
            'transfer-now-a2': '立即登记',
            'footer-p1': '重要声明及互联网私隐政策声明',
            'footer-p2': '©恒生银行有限公司',
        },
        'tc': { // 繁體
            'navbar-faster-payment-system': '快速支付系統',
            'navbar-receiving-money': '收款',
            'navbar-sending-money': '付款',
            'navbar-transfer-now': '立即行動',
            'faster-payment-system-title': '快速支付系統(FPS)',
            'faster-payment-system-p1': '了解快速支付系統怎樣運作，以及如何透過商業e-Banking啟動服務。',
            'receiving-money-title': '收&nbsp;款',
            'set-up-title': '設立FPS賬戶綁定 及 <br /> 設定預設戶口',
            // 'set-up-p1': '完成幾個簡單步驟完成，收款便可即時到戶。',
            'set-up-p1': '1. 於恒生商業e-Banking，請選擇以你的流動電話號碼、  電郵地址或FPS ID，作為快速支付賬號。',
            'set-up-p2': '2. 並以你的恒生商業戶口作為預設戶口。',
            'set-up-p3': '3. 我們會向你於本行登記的流動電話號碼／電郵地址發出一次性密碼，請於收到後輸入該密碼以核實身份。',
            'set-up-p4': '註: <br> 若以FPS ID作為你的「快速支付賬號」，毋須設定「預設戶口」及將不會收到一次性密碼核實身份。',
            'identifier-title': '向付款人提供你的快速支付賬號',
            'identifier-p1': '此後，付款人只需以你提供的快速支付賬號，便可作出付款。',
            'waiting-for-transfer-title': '收款即時到戶',
            'waiting-for-transfer-p1': '付款人付款後，款項會即時轉賬至你的 <br /> 銀行戶口。',
            'sending-money-title': '付&nbsp;款',
            'get-payee-identifier-title': '取得收款人的快速支付賬號',
            'get-payee-identifier-p1': '毋須銀行戶口號碼，只需以快速支付賬號，便可辦妥一切。如此，你的收款人便可享更大私隱保障﹗',
            'transfer-to-payee-title': '轉賬予收款人',
            'transfer-to-payee-p1': '透過網上或流動理財，即可輕鬆完成轉賬。',
            'transfer-instantly-title': '付款即時到戶',
            'transfer-instantly-p1': '全天候7x24隨時可進行付款，而且款項可近乎即時轉至收款人戶口。',
            'transfer-now-title': '立即行動',
            'transfer-now-p1': '快速支付系統現已登陸 <br /> 恒生商業e-Banking',
            'transfer-now-b1': '登入',
            'transfer-now-p2': '尚未持有恒生商業戶口？',
            'transfer-now-a1': '立即開戶',
            'transfer-now-p3': '未登記使用商業e-Banking？',
            'transfer-now-a2': '立即登記',
            'footer-p1': '重要聲明及互聯網私隱政策聲明',
            'footer-p2': '©恒生銀行有限公司',
        }
    }
    
    // 獲取默認語言
    var current_lang = localStorage.getItem('current_lang') || 'en';
    $("#" + current_lang).hide();

    // 初始化时判断是否带有参数，如果没有，加上?setLang=xx
    if (getQueryString('setLang')) {
        console.log(getQueryString('setLang'));
    } else {
        window.location.search = '?setLang=' + current_lang;
    }

    // toTranslate(current_lang);

    // 修改url進行翻譯
    var setLang = getQueryString('setLang');
    switch(setLang) {
        case 'en':
            toTranslate('en', $('#en'));
            break;
        case 'tc':
            toTranslate('tc', $('#tc'));
            break;
        case 'sc':
            toTranslate('sc', $('#sc'));
            break;
        default:
            toTranslate(current_lang, $('#'+current_lang));
    }

    // 獲取querystring
    function getQueryString(name) {
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        var r = window.location.search.substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return null;
    }
    
    // 點擊翻譯
    $('.language .translate').click(function() {
        var lang = $(this).attr('id');
        window.location.href = "?setLang="+lang;
        toTranslate(lang);
    })

    // 翻譯的操作
    function toTranslate(lang, current_ele) {
        localStorage.setItem('current_lang', lang);
        $(current_ele).siblings().css('display','block');
        $(current_ele).css('display', 'none');
        $('.faster-payment-system-content .phone').css('backgroundImage', 'url("assets/img/final/banner_mobile_' + lang + '.png")');
        $('.setup-addressing-content .address-msg .person-group').css('backgroundImage', 'url("assets/img/final/section1_account_' + lang + '.png")');
        $('#footer .HSBC').css('backgroundImage', 'url("assets/img/HSBC_' + lang + '.png")');
        $('.transfer-to-payee-content .phone-payer .img-1').attr('src', 'assets/img/sending-money-step2/phone_011_' + lang + '.png');
        $('.transfer-to-payee-content .phone-payer .img-2').attr('src', 'assets/img/sending-money-step2/phone_022_' + lang + '.png');
        $('.transfer-to-payee-content .phone-payer .img-3').attr('src', 'assets/img/sending-money-step2/phone_033_' + lang + '.png');
        $('.transfer-to-payee-content .phone-payer .img-4').attr('src', 'assets/img/sending-money-step2/phone_044_' + lang + '.png');
        $('.transfer-to-payee-content .phone-payer .img-5').attr('src', 'assets/img/sending-money-step2/phone_055_' + lang + '.png');

        $('.transfer-to-payee-content .mac-payer .img-1').attr('src', 'assets/img/sending-money-step2/mac_s2_011_' + lang + '.png');
        $('.transfer-to-payee-content .mac-payer .img-2').attr('src', 'assets/img/sending-money-step2/mac_s2_022_' + lang + '.png');
        $('.transfer-to-payee-content .mac-payer .img-3').attr('src', 'assets/img/sending-money-step2/mac_s2_033_' + lang + '.png');
        $('.setup-addressing-content .mac .img-1').attr('src', 'assets/img/receiving-money-step1/mac_011_' + lang + '.png');
        $('.setup-addressing-content .mac .img-2').attr('src', 'assets/img/receiving-money-step1/mac_022_' + lang + '.png');
        $('.setup-addressing-content .mac .img-3').attr('src', 'assets/img/receiving-money-step1/mac_033_' + lang + '.png');
        switch (lang) {
            case 'en':
                $('.payer-icon .payer-logo-icon').css('backgroundImage', 'url("assets/img/final/section1_payer_tag_en.png")');
                $('.payee-icon .payee-logo-icon').css('backgroundImage', 'url("assets/img/final/section1_payee_tag_en.png")');
                $('.payer-deep-icon .payer-deep-logo-icon').css('backgroundImage', 'url("assets/img/final/section2_payer_tag_en.png")');
                $('.payee-deep-icon .payee-deep-logo-icon').css('backgroundImage', 'url("assets/img/final/section2_payee_tag_en.png")');
                $('.setup-addressing-content .mac .mac-payee-tag').css('backgroundImage', 'url("assets/img/receiving-money-step1/mac-payee-tag.png")');
                $('.transfer-to-payee-content .mac-payer .mac-payer-tag').css('backgroundImage', 'url("assets/img/sending-money-step2/payer-tag.png")');
                $('.transfer-to-payee-content .phone-payer .phone-payer-tag').css('backgroundImage', 'url("assets/img/sending-money-step2/payer-tag.png")');
                $('#navbar-nav-phone .nav-item').each(function(index, element){
                    $(element).css('marginLeft','0');
                })
                var deviceAgent = navigator.userAgent.toLowerCase();
                if (Modernizr.touch && deviceAgent.match(/(ipad)/)) {
                    $('.setup-addressing-content').css('height', '75rem');
                }
                break;
        
            case 'sc':
            case 'tc':
                $('.payer-icon .payer-logo-icon').css('backgroundImage', 'url("assets/img/final/section1_payer_tag_cn.png")');
                $('.payee-icon .payee-logo-icon').css('backgroundImage', 'url("assets/img/final/section1_payee_tag_cn.png")');
                $('.transfer-to-payee-content .or').css('backgroundImage', 'url("assets/img/sending-money-step2/or_cn.png")');
                $('.payer-deep-icon .payer-deep-logo-icon').css('backgroundImage', 'url("assets/img/final/section2_payer_tag_cn.png")');
                $('.payee-deep-icon .payee-deep-logo-icon').css('backgroundImage', 'url("assets/img/final/section2_payee_tag_cn.png")');
                $('.setup-addressing-content .mac .mac-payee-tag').css('backgroundImage', 'url("assets/img/receiving-money-step1/mac-payee-tag_cn.png")');
                $('.transfer-to-payee-content .mac-payer .mac-payer-tag').css('backgroundImage', 'url("assets/img/sending-money-step2/payer-tag_cn.png")');
                $('.transfer-to-payee-content .phone-payer .phone-payer-tag').css('backgroundImage', 'url("assets/img/sending-money-step2/payer-tag_cn.png")');

                $('.navbar-expand-md .navbar-nav .nav-link').each(function(index, element){
                    $(element).css({
                        "paddingLeft":"30px",
                        "paddingRight":"30px"
                    });
                });
                var deviceAgent = navigator.userAgent.toLowerCase();
                if (Modernizr.touch) {
                    if (deviceAgent.match(/iphone/i)) {
                        $('.setup-addressing-content').css('height', '63rem');
                        $('.setup-addressing-content .address-msg').css('top', 'calc(42%)');
                    } else if (deviceAgent.match(/(ipad)/)) {
                        $('.setup-addressing-content').css('height', '67rem');
                        
                    }
                }
                
                break;
        }
        switch (lang) {
            case 'en':
                $('#footer .footer-content .policy').attr('href', 'https://bank.hangseng.com/1/2/important-message');
                $('.transfer-now-content .open-now').attr('href', 'https://www.biz-ebanking.hangseng.com/portalserver/digital-form/en-us/account-opening');
                $('.transfer-now-content .open-link').attr('href', 'https://www.biz-ebanking.hangseng.com/portalserver/distribution/redirectLogon.jsp?idv_cmd=idv.Authentication&nextPage=b2g.hase.launching&__targetLocale=en');
                $('.transfer-now-content .register-now').attr('href', 'https://www.biz-ebanking.hangseng.com/portalserver/distribution/redirectLogon.jsp?idv_cmd=idv.Authentication&nextPage=b2g.hase.launching&__targetLocale=en');
                break;
            case 'sc':
                $('#footer .footer-content .policy').attr('href', 'https://bank.hangseng.com/1/2/schi/important-message');
                $('.transfer-now-content .open-now').attr('href', 'https://www.biz-ebanking.hangseng.com/portalserver/digital-form/zh-cn/account-opening');
                $('.transfer-now-content .open-link').attr('href', 'https://www.biz-ebanking.hangseng.com/portalserver/distribution/redirectLogon.jsp?idv_cmd=idv.Authentication&nextPage=b2g.hase.launching&__targetLocale=zh_CN');
                $('.transfer-now-content .register-now').attr('href', 'https://www.biz-ebanking.hangseng.com/portalserver/distribution/redirectLogon.jsp?idv_cmd=idv.Authentication&nextPage=b2g.hase.launching&__targetLocale=zh_CN');

                break;
            case 'tc':
                $('#footer .footer-content .policy').attr('href', 'https://bank.hangseng.com/1/2/chi/important-message');
                $('.transfer-now-content .open-now').attr('href', 'https://www.biz-ebanking.hangseng.com/portalserver/digital-form/zh-hk/account-opening');
                $('.transfer-now-content .open-link').attr('href', 'https://www.biz-ebanking.hangseng.com/portalserver/distribution/redirectLogon.jsp?idv_cmd=idv.Authentication&nextPage=b2g.hase.launching&__targetLocale=zh_HK');
                $('.transfer-now-content .register-now').attr('href', 'https://www.biz-ebanking.hangseng.com/portalserver/distribution/redirectLogon.jsp?idv_cmd=idv.Authentication&nextPage=b2g.hase.launching&__targetLocale=zh_HK');
                break;
        }

        // 根據'.lang'進行遍歷翻譯
        $('.lang').each(function (index, element) {
            $(this).html(arrLang[lang][$(this).attr('key')])
        });
    }
    
})